// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SidebarReduced_sidebar__2w-24","sidebarClosed":"SidebarReduced_sidebarClosed__J4Les"};